import { Check, Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { CURRENCIES, useCurrencyStore } from "@/stores/currencyStore";

export const CurrencySwitcher = () => {
  const code = useCurrencyStore((s) => s.code);
  const setCode = useCurrencyStore((s) => s.setCode);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="hidden sm:inline-flex items-center justify-center transition-colors duration-300 hover:text-accent focus:outline-none"
        aria-label={`Change currency (current: ${code})`}
      >
        <Globe className="w-5 h-5" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-80 overflow-y-auto w-56">
        {CURRENCIES.map((c) => (
          <DropdownMenuItem
            key={c.code}
            onSelect={() => setCode(c.code)}
            className="flex items-center justify-between gap-2 cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <span className="font-mono text-xs w-10 text-muted-foreground">{c.code}</span>
              <span className="text-sm">{c.name}</span>
            </span>
            {c.code === code && <Check className="w-4 h-4 text-accent" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};